import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { keys } from "./keys";

async function fetchDocumentsBySubjectActionId(subjectActionId: string) {
  const { data, error } = await apiClient
    .from('documents')
    .select('*, document_types:document_type_id(id, name)')
    .eq('subject_action_id', subjectActionId)
    .order('created_at', { ascending: false });

  if (error) {
    throw error;
  }

  return (data ?? []).map((doc) => ({
    ...doc,
    type: doc.document_types?.name ?? null,
  }));
}

export function useGetDocumentsBySubjectActionId(subjectActionId: string | undefined, subTopicId: string, enabled: boolean) {

  return useQuery({
    queryKey: keys.actionDocuments(subjectActionId ?? '', subTopicId),
    queryFn: () => fetchDocumentsBySubjectActionId(subjectActionId!),
    enabled: !!subjectActionId && enabled,
  })
}
